import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT, ORDER } from '../../../../../../constants/Define';
import i18n from '../../../../../../constants/initLng';
import { getMomentDate } from '../../../../../../utils/commonUtils';
import {
    FormWrapperItem, ListComponent, StatusComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import Span from "../../../../common/component/Span";
import { Skeleton, Divider, Icon, Tooltip } from 'antd';
import Order, { OrderTourItem } from '../../../../../../models/Order';
import moment from 'moment';
import { get, sumBy, find, filter } from 'lodash';
import SurchargeInfo from '../SurchargeInfo/SurchargeInfo';

import Reservation from '../../../../../../models/Reservation';

import './HomestayInfo.less';
import Empty from '../../../../common/component/Empty';
import DetailStatusItem from '../DetailStatusItem';
import PackageRatesList from './PackageRatesList';

const ReservationsTableKeys = [
    'operaConfirmationNumber',
    'roomConfirmationNumber',
    'roomType',
    'rateCode',
    'maxAdult',
    'maxChild',
    'maxInfant',
    'orderStatus',
    'orderStatusHomestay',
    'amount',
    'original_amount',
    'markupHomestay',
    'sale_amount',
    'productVariantId',
];
const ReservationsModelKeys = Object.getOwnPropertyNames(new Reservation());
const statusDisabledChange = [3, 4, 5];

export default class HomestayInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleTable: Func.getTitleTable(['action', ...ReservationsTableKeys], [], ['amount', 'orderStatus', 'productVariantId']),
            modelKeys: ReservationsModelKeys,
            componentTable: {
                operaConfirmationNumber: {
                    width: 150
                },
                roomConfirmationNumber: {
                    width: 150
                },
                roomType: {
                    render: (text, item) => get(item, 'roomRates[0].roomType.name')
                },
                rateCode: {
                    render: (text, item) => get(item, 'roomRates[0].ratePlanCode')
                },
                maxAdult: {
                    align: "right",
                    render: (text, item) => get(item, 'roomOccupancy.numberOfAdult')
                },
                orderStatusHomestay: {
                    render: (value, item) => item.orderStatus && <StatusComponent color={this.props.t(`item.order.orderItemStatusColor.${item.orderStatus}`)}
                    label={this.props.t(`item.order.orderItemStatus.${item.orderStatus}`)} />
                },
                maxChild: {
                    align: "right",
                    render: (text, item) => get(item, 'roomOccupancy.numberOfChild')
                },
                maxInfant: {
                    align: "right",
                    render: (text, item) => get(item, 'roomOccupancy.numberOfInfant'),
                },
                sale_amount: {
                    align: "right",
                    render: (text, item) => this.renderPrices(
                        get(item, 'total.amount.amount') || 0,
                        i18n.t(`currencySymbol`), true
                    )
                },
                original_amount: {
                    align: "right",
                    render: (text, item) => {
                        const totalMarkupPrice = (get(item, 'markupPrice', [])).reduce((prevVal, currVal) => prevVal + currVal.markupExchangeToCash, 0)
                        const originAmount = get(item, 'total.amount.amount', 0) - totalMarkupPrice
                        return this.renderPrices(
                            originAmount || 0,
                            i18n.t(`currencySymbol`), true
                        )
                    }
                },
                markupHomestay: {
                    align: "right",
                    render: (text, item) => {
                        const totalMarkupPrice = (get(item, 'markupPrice', [])).reduce((prevVal, currVal) => prevVal + currVal.markupExchangeToCash, 0)
                        return this.renderPrices(
                            totalMarkupPrice || 0,
                            i18n.t(`currencySymbol`), true
                        )
                    }
                },
                action: {
                    width: 100,
                    align: 'center',
                    render: (text, record, index) => <Fragment>
                        { !statusDisabledChange.includes(record.orderStatus) && this.props.permisions.allowChangeStatus && <Tooltip title={this.props.t(`action.changeStatus`)} placement="top">
                            <Icon type="edit" className="fs20 colorPrimary" onClick={() => this.onClickChangeStatus(record, this.props.homestays[index].productVariantId)} />
                        </Tooltip>
                        }
                        {
                            // this.props.allowSurcharge && 
                            // <Tooltip title='Thêm phụ thu' placement="top">
                            //     <Icon type="file-add" className="fs20 colorPrimary" onClick={() => this.props.createModalSurcharge(this.props.homestays[0].productVariantId, ORDER.TYPES.HOMESTAY.id)} />
                            // </Tooltip>
                        }
                        </Fragment>
                }
            },
            expandedRows: [],
            dataItem: null
        };
    }

    render() {
        const { t, order } = this.props;

        return (
            <Wrapper className="tour-info-section col-md-12 mb-3">
                {order.itemTypes.includes(ORDER.TYPES.HOMESTAY.id) ?
                    <>
                        <h3 className={`ml-0`}>{t('item.order.homestayBookingDetailInfo')}</h3>
                        <Wrapper className={`row mt-2`}>
                            {this.renderHomestayInfo()}
                            {this.renderReservationList()}
                            <PackageRatesList reservations={this.props?.reservations || []} loading={this.props?.loading} />
                        </Wrapper>
                    </> :
                    <Wrapper className={`row mt-2`}>
                        <PackageRatesList reservations={this.props?.reservations || []} loading={this.props?.loading} />
                    </Wrapper>
                }
            </Wrapper>
        );
    }

    renderHomestayInfo() {
        const { t, loading, reservations } = this.props;
        const reservation = get(this.props, 'reservations[0]') || {};
        const homestay = reservation.hotelInfo;
        // const profile = get(reservation, 'profiles[0]') || {};
        const profile = reservation.profiles && reservation.profiles.find((profile) => profile.profileType === "Guest" || profile.profileType === "Booker")
        const lengthOfStay = reservation.lengthOfStay || 0;
        const arrivalDate = reservation.arrivalDate && reservation.arrivalDate.format(DATE_TIME_FORMAT.SHORT_DATE);
        const checkoutDate = reservation.arrivalDate && moment(reservation.arrivalDate).add(lengthOfStay, 'days').format(DATE_TIME_FORMAT.SHORT_DATE);
        const totalAmount = sumBy(reservations, 'total.amount.amount') || 0;
        return (
            <FormWrapperItem className="col-md-12" classChildren="m-0 p-0">
                {homestay && !loading ?
                    <Fragment>
                        <ul className={`col-md-6 row m-0 p-0 pl-4`}>
                            <h4 className={`col-md-12 mb-3 pl-0 orange-color-text`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.profile')}</Span>
                                </Wrapper>
                            </h4>
                            <li className={`col-md-12 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.profileName')}:</Span> {
                                        `${profile.firstName}${profile.middleName ? (' ' + profile.middleName) : ''}${profile.lastName ? (' ' + profile.lastName) : ''}`
                                    }
                                </Wrapper>
                            </li>
                            <li className={`col-md-12 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.profileEmail')}:</Span> {profile.email}
                                </Wrapper>
                            </li>
                            <li className={`col-md-12 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.profilePhoneNumber')}:</Span> {profile.phoneNumber}
                                </Wrapper>
                            </li>
                        </ul>
                        <ul className={`col-md-6 row m-0 p-0 pl-2`}>
                            <h4 className={`col-md-12 mb-3 pl-0 orange-color-text`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.homestayInfo')}</Span>
                                </Wrapper>
                            </h4>
                            <li className={`col-md-12 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.homestay.name')}:</Span> {homestay.name}
                                </Wrapper>
                            </li>
                            <li className={`col-md-12 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.homestay.address')}:</Span> {homestay.address}
                                </Wrapper>
                            </li>
                            <li className={`col-md-12 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.homestay.hotline')}:</Span> {homestay.hotline}
                                </Wrapper>
                            </li>
                        </ul>
                        <Divider />
                        <ul className={`col-md-12 row m-0 p-0 pl-4`}>
                            <h4 className={`col-md-12 mb-3 pl-0 orange-color-text`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.homestayBookingInfo')}</Span>
                                </Wrapper>
                            </h4>
                            <li className={`col-md-6 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.homestayRoomLength')}:</Span> {reservations.length}
                                </Wrapper>
                            </li>
                            <li className={`col-md-6 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.homestayLengthOfStay')}:</Span> {lengthOfStay}
                                </Wrapper>
                            </li>
                            <li className={`col-md-6 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.arrivalDate')}:</Span> {arrivalDate}
                                </Wrapper>
                            </li>
                            <li className={`col-md-6 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.checkoutDate')}:</Span> {checkoutDate}
                                </Wrapper>
                            </li>
                            <li className={`col-md-6 mb-3 pl-0`}>
                                <Wrapper>
                                    <Span className={`semi-bold`}>{t('item.order.totalAmount')}:</Span> {
                                        this.renderPrices(totalAmount, i18n.t(`currencySymbol`), true)
                                    }
                                </Wrapper>
                            </li>
                        </ul>
                    </Fragment>
                    : (loading ?
                        <ul className={`col-md-12 row m-0 p-0 pl-4`}>
                            <li className={`col-md-6 mb-3 pl-0`}><Skeleton active paragraph={{ row: 4 }} className="p-4" /></li>
                            <li className={`col-md-6 mb-3 pl-0`}><Skeleton active paragraph={{ row: 4 }} className="p-4" /></li>
                            <li className={`col-md-12 mb-3 pl-0`}><Skeleton active paragraph={{ row: 4 }} className="p-4" /></li>
                        </ul>
                        : <Wrapper style={{ width: '100%' }}>
                            <Empty />
                        </Wrapper>
                    )
                }
            </FormWrapperItem>
        )
    }

    renderReservationList() {
        const { reservations, loading, t } = this.props;
        const { titleTable, modelKeys, componentTable, expandedRows, dataItem } = this.state;

        return (
            <FormWrapperItem classParent="p-0 m-0 no-border" classChildren="m-0 p-0">
                {!loading ?
                    <ListComponent
                        classParent="m-0 p-0 col-md-12"
                        classChildren="p-0 m-0"
                        marginTop={'0'} marginBottom={'0'}
                        loading={{ spinning: loading, size: 'large' }}
                        rowKey={(record, k) => k}
                        dataSource={Func.getDataSource(reservations || [], modelKeys)}
                        columns={Func.columnsTable({ titleTable: titleTable, component: componentTable, itemName: 'order' })}
                        componentTableList={{}}
                        expandedRowRender={this.renderSurcharge}
                        onExpand={this.onRowExpanded}
                        onColumnVisibleChange={this.onColumnVisibleChange}
                        expandedRowKeys={expandedRows}
                        onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
                    />
                    : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                }
                <DetailStatusItem 
                    title={`${t('item.order.changeStatus')} ${t('item.homestay.title').toLowerCase()}`}
                    visible={!!dataItem}
                    onSave={this.onSaveStatus}
                    itemTypes={ORDER.TYPE_ITEM['4']}
                    onClose={() => this.setState({ dataItem: null })}
                    item={dataItem || {}}
                    keyName={'operaConfirmationNumber'}
                    keyStatus={'orderStatus'}
                />
            </FormWrapperItem>
        )
    }

    renderSurcharge = (record, index, indent, expanded) => {
        return (
            <SurchargeInfo
                listType='homestays'
                removeSurcharge={this.props.removeSurcharge}
                surcharges={record.detail.items}
                loading={false}
                openModalDetail={this.props.openDetailSurcharge}
            />
        )
    }

    onRowExpanded = (expanded, record) => {
        record.itemVariantId = this.props.homestays[0].productVariantId;
        if (expanded && record.itemVariantId) {
            this.props.onItemExpanded(expanded, record, 'hotels')
        }
    }

    renderPrices(price, currency, quantity) {
        return (
            <Span className="prices">
                {quantity && <Span>{quantity > 1 ? `${quantity}x` : ''}{Func.formatMoney(price)}</Span>}{`${currency || ''}`}
            </Span>
        )
    }

    getOtherOccupancies = (refCode, otherOccupancies = []) => {
        return find(otherOccupancies, item => item.otherOccupancyRefCode === refCode) || {}
    }

    onClickChangeStatus = (item, productVariantId) => {
        item.productVariantId = productVariantId
        this.setState({ dataItem: item })
    }

    onSaveStatus = (orderItem) => {
        if(this.props.onUpdateItem){
            orderItem.orderItemType = 4;
            this.props.onUpdateItem(orderItem)
        }
        this.setState({ dataItem: null })
    }
}

HomestayInfo.defaultProps = {
    order: new Order(),
    loading: false,
    reservations: [],
};